
    /**
     * 首页容器
     */
    import {Component, Vue} from "vue-property-decorator";

    @Component
    export default class ShareHomeLayout extends Vue {
    }
